// window.onload = function () {
//   // --- ブラウザのデフォルト言語を取得して初回の表示 -----
// }
// const dataLang = JSON.parse(localStorage.getItem('lang'))
const inputs = document.querySelectorAll('.c-lang_input')

function getBrowserLanguage() {
  const wDef = (
    navigator.browserLanguage ||
    navigator.language ||
    navigator.userLanguage
  ).substr(0, 2)
  return wDef
}
// function init(inputs) {
//   const getLang = getBrowserLanguage()
//   const lang = dataLang || getLang

//   inputs.forEach(el => {
//     const elementLang = el.getAttribute('data-lang')
//     if (elementLang === lang) {
//       el.checked = true
//       console.log(elementLang === lang)
//     } else {
//       el.checked = false
//       console.log(elementLang === lang)
//     }
//   })

//   localStorage.setItem('lang', JSON.stringify(lang))
// }

function localeSwitch(lang) {
  switch (lang) {
    case 'ja':
      window.location.href = './index.html'
      // window.location.href = `${targetLocation}`
      break
    case 'en':
      window.location.href = './index-en.html'
      // window.location.href = 'https://www.google.co.jp/'
      break
    default:
      window.location.href = './index.html'
    // window.location.href = 'https://www.yahoo.co.jp/'
  }
}

function switchEvent(inputs) {
  inputs.forEach((el, index, arr) => {
    const elementLang = el.getAttribute('data-lang')
    el.addEventListener('change', () => {
      localeSwitch(elementLang)
      // localStorage.setItem('lang', JSON.stringify(elementLang))
    })
  })
}

// init(inputs)
switchEvent(inputs)
